import React from 'react'
import styles from './editprofile.module.css'
import Facebook from '../../../src/assets/images/icon/fb.svg'
import Twitter from '../../../src/assets/images/icon/tw.svg'
import Linkedin from '../../../src/assets/images/icon/lind.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faGlobe } from '@fortawesome/free-solid-svg-icons'

const neweditprofile = () => {
  return (
    <div>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['profile-cards']}`}>
                        <div className='d-flex justify-content-between align-items-center'>
                        <h2 className="mb-3">Edit Profile</h2>
                        <a className={`${styles['submit-btn']} btn`} href='#'><FontAwesomeIcon icon={faEye} className='pe-2'/>View Profile</a>
                        </div>
                        <hr/>
                        <form className={`${styles['forms-card']}`}>
                        <div className='border rounded-3 p-2 mb-3'>
                            <div className={`${styles['inner-title']}`}>
                            Contact Details
                            </div>
                            <div className="row g-3">
                            <div className="col-md-4">
                                <label htmlFor="primaryEmail" className={`${styles['label-ct']} form-label`}>
                                Primary Email <span className="text-danger">*</span>
                                </label>
                                <input type="email" className="form-control" id="primaryEmail" placeholder="Enter primary email" required/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="secondaryEmail" className={`${styles['label-ct']} form-label`}>
                                Secondary Email <span className="text-danger">*</span>
                                </label>
                                <input type="email" className="form-control" id="secondaryEmail" placeholder="Enter secondary email" required/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="mobileNumber" className={`${styles['label-ct']} form-label`}>
                                Mobile Number <span className="text-danger">*</span>
                                </label>
                                <input type="text" className="form-control" id="mobileNumber" placeholder="Enter mobile number" required/>
                            </div>
                            </div>
                        </div>
                        <div className="border rounded-3 p-2 mb-3">
                            <div className={`${styles['inner-title']}`}>
                            Company Details
                            </div>
                            <div className="row g-3">
                            <div className="col-md-4">
                                <label htmlFor="role" className={`${styles['label-ct']} form-label`}>
                                Role <span className="text-danger">*</span>
                                </label>
                                <select className="form-select" id="role" required>
                                    <option value="">Select contact person's role</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="companyName" className={`${styles['label-ct']} form-label`}>
                                Company Name <span className="text-danger">*</span>
                                </label>
                                <input type="text" className="form-control" id="companyName" placeholder="Enter company name" required/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="companyCategory" className={`${styles['label-ct']} form-label`}>
                                Company Category <span className="text-danger">*</span>
                                </label>
                                <select className="form-select" id="companyCategory" required>
                                    <option value="">Select company category</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="companyType" className={`${styles['label-ct']} form-label`}>
                                Company Type <span className="text-danger">*</span>
                                </label>
                                <select className="form-select" id="companyType" required>
                                    <option value="">Select company type</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="industry" className={`${styles['label-ct']} form-label`}>
                                Industry <span className="text-danger">*</span>
                                </label>
                                <select className="form-select" id="industry" required>
                                    <option value="">Select industry</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="location" className={`${styles['label-ct']} form-label`}>
                                Location <span className="text-danger">*</span>
                                </label>
                                <input type="text" className="form-control" id="location" placeholder="Enter location" required/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="pincode" className={`${styles['label-ct']} form-label`}>
                                Pincode <span className="text-danger">*</span>
                                </label>
                                <input type="text" className="form-control" id="pincode" placeholder="Enter pincode" required/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="contactPerson" className={`${styles['label-ct']} form-label`}>
                                Contact Person <span className="text-danger">*</span>
                                </label>
                                <input type="text" className="form-control" id="contactPerson" placeholder="Enter contact person name" required/>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="designation" className={`${styles['label-ct']} form-label`}>
                                Designation <span className="text-danger">*</span>
                                </label>
                                <select className="form-select" id="designation" required>
                                    <option value="">Select designation</option>
                                </select>
                            </div>
                            </div>
                        </div>
                        <div className="border rounded-3 p-2 mb-3">
                        <h3 className={`${styles['inner-title']}`}>Profile Information</h3>
                            <form>
                                <div className='row'>
                                <div className="col-md-4 mb-3">
                                    <label className={`${styles['label-ct']} form-label`}>Company Size *</label>
                                    <input type="col-md-4 text" className="form-control" placeholder="Enter company size" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className={`${styles['label-ct']} form-label`}>Founded Year *</label>
                                    <input type="number" className="form-control" defaultValue="2024" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className={`${styles['label-ct']} form-label`}>Headquarters *</label>
                                    <input type="text" className="form-control" placeholder="Enter headquarter place" />
                                </div>
                                </div>
                                <div className="mb-3">
                                    <label className={`${styles['label-ct']} form-label`}>Website *</label>
                                    <div className='d-flex align-items-center justify-content-center'>
                                        <FontAwesomeIcon className='me-1 fs-2' icon={faGlobe}/><input type="url" className="form-control" placeholder="Enter website URL" />
                                    </div>
                                </div>
                                <label className={`${styles['label-ct']} form-label`}>Social Media *</label>
                                <div className="mb-3">
                                    <div className='d-flex align-items-center justify-content-center'>
                                    <img src={Facebook} className='me-2 h2'/>
                                    <input type="url" className="form-control mb-2" placeholder="www.facebook.com/" />
                                    </div>
                                    <div className='d-flex align-items-center justify-content-center'>
                                    <img src={Twitter} className='me-2 h2'/>
                                    <input type="url" className="form-control mb-2" placeholder="www.twitter.com/" />
                                    </div>
                                    <div className='d-flex align-items-center justify-content-center'>
                                    <img src={Linkedin} className='me-2 h2'/>
                                    <input type="url" className="form-control mb-2" placeholder="www.linkedin.com/in/" />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <textarea className="form-control" placeholder="Enter about company" maxLength="1000"></textarea>
                                    <small className="text-muted">249/1000 Characters Left</small>
                                </div>
                            </form>
                        </div>
                        <div className="d-flex justify-content-end mt-4">
                            <button type="button" className={`${styles['cancel-btn']} btn me-2`}>
                            Cancel
                            </button>
                            <button type="submit" className={`${styles['submit-btn']} btn`}>
                            Submit
                            </button>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
            </div>
    </div>
  )
}

export default neweditprofile